import { z } from 'zod';

export const productZ = z.object({
  label: z.string().min(1, 'Name is required'),
  description: z.string().optional(),
  priceInCents: z.string().min(1, 'Price is required'),
  collectTaxes: z.boolean(),
  customerVisible: z.boolean(),
  archived: z.boolean().optional(),
  history: z.array(z.object({
    createdAt: z.date(),
    createdBy: z.string(),
    reason: z.string().optional(),
  })).optional(),
});

export type ProductFormValues = z.infer<typeof productZ>;
